import React from 'react';

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='26'
      height='26'
      viewBox='0 0 26 26'
    >
      <path d='M8.5 6C2.5 6 0 6.813 0 7.469V18.5c0 .64 2.5 1.5 8.5 1.5s8.5-.813 8.5-1.469V7.5C17 6.86 14.5 6 8.5 6zm16.875.031a.882.882 0 00-.469.157l-6.5 4.187a1.03 1.03 0 00-.406.813v3.624c0 .313.156.626.406.813l6.5 4.188c.176.132 1.032.55 1.032-.813V7c0-.79-.27-.98-.563-.969z'/>
    </svg>
  );
}

export default Icon;
